import React from 'react';
import { validateMacAddress } from '../../../../settings/venue/device/NetworkConfig/networkUtils';
import StringField from '../../../fields/StringField';

const MacAddressField = ({ processor, updateObject, hub, cellControl }) => {

    const macAddress = processor.macAddress;
    const validationError = validateMacAddressField(processor, hub);

    const setValueHandler = (value) => {
        const lowerCaseString = value.toLowerCase();
        updateObject({ macAddress: lowerCaseString });
    }
    
    return (
        <StringField
            value={macAddress}
            setValue={(value) => setValueHandler(value)}
            error={validationError}
            cellState={cellControl.cellState}
            disabled={false}
        />
    )
}
export default MacAddressField;

export const validateMacAddressField = (processor, hub) => {
    const macAddress = processor.macAddress;
    if (!macAddress) return null;

    var validationError = null;
    if (!validateMacAddress(macAddress)) {
        validationError = { message: 'Not a valid mac address', type: 'ERROR' };
    }
    return validationError;
}